import axios from 'axios';
import {
  AcreditacionResult,
  NominacionPuertaRequest,
  VentaPuertaRequest,
  ArqueoCajaOperador,
  AsistenciaOfflineItem
} from '../types/acreditacion.types';

const API_BASE = '/api/acreditacion';

export const acreditacionApi = {
  acreditarQr: async (codigoQr: string): Promise<AcreditacionResult> => {
    const { data } = await axios.post<AcreditacionResult>(`${API_BASE}/escanear-qr`, {
      codigoQr
    });
    return data;
  },

  nominarPuerta: async (req: NominacionPuertaRequest): Promise<AcreditacionResult> => {
    const { data } = await axios.post<AcreditacionResult>(`${API_BASE}/nominar-puerta`, req);
    return data;
  },

  buscarManual: async (idCongreso: number, termino: string): Promise<AcreditacionResult[]> => {
    const { data } = await axios.get<AcreditacionResult[]>(`${API_BASE}/buscar-manual/${idCongreso}`, {
      params: { termino }
    });
    return data;
  },

  registrarVentaPuerta: async (req: VentaPuertaRequest): Promise<AcreditacionResult> => {
    const { data } = await axios.post<AcreditacionResult>(`${API_BASE}/venta-puerta`, req);
    return data;
  },

  obtenerArqueoCaja: async (fecha?: string): Promise<ArqueoCajaOperador> => {
    const { data } = await axios.get<ArqueoCajaOperador>(`${API_BASE}/mi-arqueo`, {
      params: { fecha }
    });
    return data;
  },

  sincronizarLoteOffline: async (items: AsistenciaOfflineItem[]): Promise<{ sincronizadas: number }> => {
    const payload = items.map(i => ({
      codigoQr: i.codigoQr,
      fechaLecturaOffline: i.fechaLectura
    }));
    const { data } = await axios.post<{ sincronizadas: number }>(`${API_BASE}/sincronizar-lote`, payload);
    return data;
  },

  obtenerTerminalesPoint: async (): Promise<import('../types/acreditacion.types').TerminalPointDto[]> => {
    const { data } = await axios.get<import('../types/acreditacion.types').TerminalPointDto[]>(`${API_BASE}/terminales-point`);
    return data;
  },

  crearIntencionPoint: async (req: import('../types/acreditacion.types').CrearIntencionPointRequest): Promise<import('../types/acreditacion.types').IntencionPointEstadoDto> => {
    const { data } = await axios.post<import('../types/acreditacion.types').IntencionPointEstadoDto>(`${API_BASE}/point/intencion-cobro`, req);
    return data;
  },

  consultarEstadoIntencionPoint: async (idIntencion: number): Promise<import('../types/acreditacion.types').IntencionPointEstadoDto> => {
    const { data } = await axios.get<import('../types/acreditacion.types').IntencionPointEstadoDto>(`${API_BASE}/point/intencion-cobro/${idIntencion}/estado`);
    return data;
  },

  cancelarIntencionPoint: async (idIntencion: number): Promise<boolean> => {
    const { data } = await axios.post<boolean>(`${API_BASE}/point/intencion-cobro/${idIntencion}/cancelar`);
    return data;
  }
};
